var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMastercard = function SvgMastercard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 780 500"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M40 0h700c22.1 0 40 17.9 40 40v420c0 22.1-17.9 40-40 40H40c-22.1 0-40-17.9-40-40V40C0 17.9 17.9 0 40 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF5F00",
    d: "M309.2 104.8h161.6v290.4H309.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#EB001B",
    d: "M319.5 250c-.1-56.7 26-110.2 70.5-145.2-80.2-63-196.3-49.1-259.3 31.1s-49.1 196.3 31.1 259.3c67 52.6 161.3 52.6 228.2 0A184.1 184.1 0 0 1 319.5 250"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#F79E1B",
    d: "M688.8 250c0 102-82.7 184.7-184.6 184.7-41.4 0-81.6-13.9-114.1-39.5 80.2-63 94.1-179.2 31-259.3-9.1-11.5-19.5-22-31-31 80.2-63 196.3-49.1 259.3 31.1a184.4 184.4 0 0 1 39.4 114m-17.6 114.4v-5.9h2.4v-1.2h-6.1v1.2h2.4v5.9zm11.8 0v-7.2h-1.9l-2.2 4.9-2.2-4.9H675v7.2h1.3V359l2 4.7h1.4l2-4.7v5.4z"
  })));
};
export default SvgMastercard;